import {Alert, Button, Grid, Heading, Image, Text, VStack} from '@chakra-ui/react';
import {useAuth} from '../auth/useAuth';
import {version} from '../env';

const BACKGROUND_IMAGE = '/camera-with-lens-background.jpg';

/** The signed-out page, shown for every URL without a session: a photo background, the logo and the sign-in button. */
export function LandingPage() {
    const {isAuthenticating, error, login} = useAuth();

    return (
        // The empty first row and the footer's row share the free space, so the content stays in the exact centre.
        <Grid
            minH="100dvh"
            templateRows="1fr auto 1fr"
            px={4}
            color="white"
            bgColor="#333"
            bgImage={`linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.7)), url(${BACKGROUND_IMAGE})`}
            bgSize="cover"
            bgPos="center"
        >
            <VStack gridRow={2} gap={{base: 4, lg: 5}} w="full" maxW={{base: '28rem', lg: '36rem'}} mx="auto" py={8} textAlign="center">
                <Image src="/logo192.png" alt="SPOT logó" boxSize={{base: '96px', lg: '128px'}} borderRadius="xl" boxShadow="lg"/>
                <Heading as="h1" size={{base: '3xl', lg: '5xl'}} color="white">SPOT Albumkezelő</Heading>
                <Text display={{base: 'none', md: 'block'}} fontSize={{base: 'lg', lg: '2xl'}}>Üdvözlünk a SPOT Fotókör albumkezelőjében!</Text>
                <Text color="whiteAlpha.800" fontSize={{base: 'md', lg: 'lg'}}>
                    Jelentkezz be a Simonyis Google fiókoddal a SPOT megosztott meghajtóinak böngészéséhez.
                </Text>
                <Button
                    colorPalette="blue"
                    size="lg"
                    h={{lg: '14'}}
                    px={{lg: '8'}}
                    fontSize={{lg: 'xl'}}
                    mt={2}
                    loading={isAuthenticating}
                    loadingText="Bejelentkezés..."
                    onClick={login}
                >
                    Bejelentkezés
                </Button>
                {error &&
                    <Alert.Root status="error" variant="solid" textAlign="start">
                        <Alert.Indicator/>
                        <Alert.Title>{error}</Alert.Title>
                    </Alert.Root>
                }
            </VStack>
            <Text gridRow={3} alignSelf="end" py={3} fontSize={{base: 'xs', lg: 'sm'}} color="whiteAlpha.700" textAlign="center">
                v{version()} · Made with ❤️ by TBeni
            </Text>
        </Grid>
    );
}
